import {takeEvery, put, fork, call, all, select} from 'redux-saga/effects';
import * as rs from './disputeResolutionSlice';
import * as uis from '../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../Auth';
import { createReceiptForFailedPaymentApi, searchFailedPaymentsApi } from './disputeResolutionApi';


export const actionTypes = {
    SearchFailedPayments: "[SearchFailedPayments] Search Failed Payments API Action",
    CreateReceiptForFailedPayment: "[CreateReceiptForFailedPayment] Create Receipt For Failed Payment API Action"
};

export const actions = {

    searchFailedPayments: (search) => ({ type: actionTypes.SearchFailedPayments, payload: { search } }),
    createReceiptForFailedPayment: (paymentSearch) => ({ type: actionTypes.CreateReceiptForFailedPayment, payload: { paymentSearch } } )

};

//watchers
export function* onSearchFailedPaymentsStartAsync({ payload }){

    try{
        
        yield put(rs.actions.startCall({ callType: rs.callTypes.list }));

        const getAuth = (state) => state.auth;

        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: payload.search
        };

        const response = yield call(searchFailedPaymentsApi, reqBody);       
        
        if(response.status === 200){
            let foundFailedPayments = response.data;
            yield put(rs.actions.failedPaymentsSearched({ foundFailedPayments }));
        }
    }

    catch(error){

        console.log(error);

        let errorMsg = "There was an error searching for failed payments.";

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {

            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));

            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }


            yield put(rs.actions.catchError({
                callType: rs.callTypes.list,
                error: errorMsg
            }));
        }
    }

};

export function* onCreateReceiptForFailedPaymentStartAsync({ payload }){

    let pdfReceiptStr = "";
    let receiptGeneratedStatus = false;

    try{
        
        yield put(rs.actions.startCall({ callType: rs.callTypes.action }));

        const getAuth = (state) => state.auth;

        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            sessionkey: auth.sessionKey,
            input: payload.paymentSearch
        };

        const response = yield call(createReceiptForFailedPaymentApi, reqBody);        

        if(response.status === 200){
            pdfReceiptStr = response.data;
            receiptGeneratedStatus = "success";
        } else {
            pdfReceiptStr = "";
            receiptGeneratedStatus = "fail";
        }

        yield put(rs.actions.failedPaymentReceiptCreated({ pdfReceiptStr, receiptGeneratedStatus  }));

    }
    //if axious throws when be returns Non-200 HTTP status codes
    catch(error){

        pdfReceiptStr = "";
        receiptGeneratedStatus = "fail";

        yield put(rs.actions.failedPaymentReceiptCreated({ pdfReceiptStr, receiptGeneratedStatus  }));

        let errorMsg = "There was an error creating receipt for the selected failed payment.";

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {

            if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uis.actions.error({ status, msg }));

            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uis.actions.error({ status, msg }));
            }


            yield put(rs.actions.catchError({
                callType: rs.callTypes.action,
                error: errorMsg
            }));
        }
    }

};

//workers
export function* searchFailedPayments(){

    yield takeEvery(actionTypes.SearchFailedPayments,onSearchFailedPaymentsStartAsync);    
};

export function* createReceiptForFailedPayment() {

    yield takeEvery(actionTypes.CreateReceiptForFailedPayment,onCreateReceiptForFailedPaymentStartAsync);
};

const disputeResolutionSagas = [
    fork(searchFailedPayments),
    fork(createReceiptForFailedPayment)
];

export function* saga(){
    yield all ([...disputeResolutionSagas]);
};
